export enum LocationEnum {
    urban = 1,
    rural = 2
}
